/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import isEmpty from 'lodash/isEmpty';
import { ofType } from 'redux-observable';
import { combineLatest, of } from 'rxjs';
import { mergeMap, pluck, withLatestFrom } from 'rxjs/operators';
import {
    COMPILE_FINAL_DISPLAYABLE_AVAILABILITIES,
    FILTER_AVAILABILITIES_BY_INPUT_COMPLETE,
    MAP_CAMPSITE_IDS_DESELECTED,
    MAP_CAMPSITE_IDS_SELECTED,
    SORT_AVAILABILITIES_COMPLETE,
} from '../../constants';

/**
 *
 * @param {Observable} action$ - a stream of actions
 * @param {Observable} state$ - a stream of redux store states
 */
export const compileDisplayableAvailabilitiesEpic = (action$, state$) =>
    action$.pipe(
        ofType(
            FILTER_AVAILABILITIES_BY_INPUT_COMPLETE, // when new campsite monthly availability data are fetched, combined, and filtered by search campsites
            SORT_AVAILABILITIES_COMPLETE, // when all filter op are completed
            MAP_CAMPSITE_IDS_SELECTED, // when map moves and filter is active
            MAP_CAMPSITE_IDS_DESELECTED // when removing the option to filter, clear ids
        ),
        withLatestFrom(combineLatest(state$.pipe(pluck('availabilityGrid')))),
        mergeMap((stream) => {
            const states = stream[1];
            const [availabilityGrid] = states;
            const {
                sortedAvailabilities,
                filteredAvailabilitiesByMapIds,
                filteredAvailabilitiesByInput,
            } = availabilityGrid;

            const sortedAvailabilitiesFilteredByInput = sortedAvailabilities.filter(
                (id) => filteredAvailabilitiesByInput[id]
            );

            const sortedFilteredAvailabilities = isEmpty(filteredAvailabilitiesByMapIds)
                ? sortedAvailabilitiesFilteredByInput
                : sortedAvailabilitiesFilteredByInput.reduce((result, id) => {
                      if (filteredAvailabilitiesByMapIds[id]) {
                          result.push(id);
                      }
                      return result;
                  }, []);

            return of({
                type: COMPILE_FINAL_DISPLAYABLE_AVAILABILITIES,
                payload: sortedFilteredAvailabilities,
            });
        })
    );
